import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function SupportCTA() {
  return <section className="py-12 bg-gradient-to-r from-brand-purple-600 to-brand-purple-700 text-white" data-id="element-595" data-mp="3uqt7fd7vf9cr">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-596" data-mp="3g26jin46h99x">
        <h2 className="text-3xl font-bold mb-6" data-id="element-597" data-mp="3kzosgdi73ohx">Need Help?</h2>
        <p className="text-brand-purple-100 text-lg mb-8" data-id="element-598" data-mp="3kxu933mko4fy">
          Our local support team is here to answer your questions about classes,
          requirements, or technical issues.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-599" data-mp="hh5bi74yw52f">
          <a href="tel:6023776207" className="group flex items-center bg-white text-brand-purple-900 px-8 py-4 rounded-full font-bold text-xl hover:bg-brand-orange-400 hover:text-white transition-colors shadow-lg" data-id="element-600" data-mp="2lpdjr19np0r">
            <Phone className="w-6 h-6 mr-3 group-hover:animate-pulse" data-id="element-601" data-mp="2sbspir2190cp" />
            602-377-6207
          </a>
          <span className="text-brand-purple-100 font-medium" data-id="element-602" data-mp="29tggymrolou1">
            Call, Text, Chat or Email us
          </span>
        </div>
      </div>
    </section>;
}